import { NgModule } from "@angular/core";
import { CommonModule } from '@angular/common';
import {RouterModule} from "@angular/router";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {FileUploadModule} from 'ng2-file-upload';
import {CheckboxModule} from 'primeng/primeng';
import {DataTableModule} from "../../../components/common/datatables/datatable.module";
import {ClientsService} from "../../../models/clients/clients.service";
import {ClientVolumesService} from "../../../models/client-volumes/client-volumes.service";
import {ClientContactsService} from "../../../models/client-contacts/client-contacts.service";
import {ClientBanksService} from "../../../models/client-banks/client-banks.service";
import {ClientOwnersService} from "../../../models/client-owners/client-owners.service";
import {ClientProcessorsService} from "../../../models/client-processors/client-processors.service";
import {ClientFormsModule} from "../../../modules/client-forms/client-forms.module";
import {PricingsService} from "../../../models/pricings/pricings.service";
import {PermissionsService} from "../../../services/permissions/permissions.service";
import {PipesModule} from "../../../pipes/pipes.module";
import {ClientStatusModule} from "../../../modules/client-status/client-status.module";
import {AccountsModule} from "../../../modules/accounts/accounts.module";
import {ClientNotesModule} from "../../../modules/client-notes/client-notes.module";
import {IncompleteModule} from "../../../modules/incomplete/incomplete.module";
import {BadgesService} from "../../../models/badges/badges.service";
import {PricingTableModule} from "../../../modules/pricing-table/pricing-table.module";
import {BadgesHelper} from "../../../services/BadgesHelper";
import {BreadcrumbsModule} from "../../../components/common/breadcrumbs/breadcrumbs.module";
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {BatchPaymentsService} from '../../../models/batch-payments/batch-payments.service';
import {DatepickerModule} from '../../../directives/datepicker/datepicker.module';
import {ClientAccountsService} from '../../../models/client-accounts/client-accounts.service';
import {ProcessingComponent} from './processing.component';
import {ProcessingItemComponent} from './item/processing-item.component';
import {ConfirmModule} from '../../../modules/confirm/confirm.module';


@NgModule({
    imports: [
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
        DataTableModule,
        CommonModule,
        AccountsModule,
        IncompleteModule,
        PipesModule,
        ClientStatusModule,
        ClientNotesModule,
        ClientFormsModule,
        PricingTableModule,
        BreadcrumbsModule,
        NgbModule,
        DatepickerModule,
        FileUploadModule,
        CheckboxModule,
        ConfirmModule
    ],
    declarations: [
        ProcessingComponent,
        ProcessingItemComponent
    ],
    exports: [
        ProcessingComponent,
        ProcessingItemComponent
    ],
    providers: [
        ClientsService,
        ClientVolumesService,
        ClientContactsService,
        ClientBanksService,
        ClientOwnersService,
        ClientProcessorsService,
        PricingsService,
        PermissionsService,
        BadgesService,
        BadgesHelper,
        BatchPaymentsService,
        ClientAccountsService
    ]
})

export class ProcessingModule {
}


// WEBPACK FOOTER //
// ./src/app/views/accounting/processing/processing.module.ts